import React from 'react'
import PropTypes from 'prop-types'

export default function Phone ({ children }) {
  const phoneNumber = children.replace(/(\d\d)(\d\d\d)(\d\d)(\d\d\d)/, '$1 $2 $3 $4')

  return (
    <span style={{whiteSpace: "nowrap"}}>{phoneNumber}</span>
  )
}

Phone.propTypes = {
  children: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Phone/index.js